export default __webpack_public_path__ + "static/bed-bath-beyond-10-9e911dd4fb99e6cef1f07b70cbfee453.gif";